import React from 'react';

import { SiteConfigManager } from '@atlas/core';

import SocialLink from 'components/Footer/FooterSocial/SocialLink';

const FooterSocial = () => {
  const socialLinks = SiteConfigManager.getConfig('config.config.social_links', []);

  if (socialLinks.length === 0) {
    return null;
  }

  return (
    <div className="social">
      {socialLinks.map(
        socialLink =>
          socialLink.link && <SocialLink key={socialLink.key} socialLink={socialLink} />,
      )}
    </div>
  );
};

export default FooterSocial;
